import { render, staticRenderFns } from "./ElementGroupConfig.vue?vue&type=template&id=1bf32c2d&"
import script from "./ElementGroupConfig.vue?vue&type=script&lang=js&"
export * from "./ElementGroupConfig.vue?vue&type=script&lang=js&"
import style0 from "./ElementGroupConfig.vue?vue&type=style&index=0&id=1bf32c2d&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bf32c2d')) {
      api.createRecord('1bf32c2d', component.options)
    } else {
      api.reload('1bf32c2d', component.options)
    }
    module.hot.accept("./ElementGroupConfig.vue?vue&type=template&id=1bf32c2d&", function () {
      api.rerender('1bf32c2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/contents/survey-paper-manage/ElementGroupConfig.vue"
export default component.exports